import Vue from "vue";

Vue.component("InputComponent", () => import("./components/element/InputComponent.vue"));
Vue.component("InputCitizenIdWithholding", () => import("./components/element/InputCitizenIdWithholding.vue"));
Vue.component("ButtonStyle", () => import("./components/element/ButtonStyle.vue"));
Vue.component("ButtonDropdown", () => import("./components/element/ButtonDropdown.vue"));
Vue.component("InputDropdown", () => import("./components/element/InputDropdown.vue"));
Vue.component("InputStatementPasscode", () => import("./components/element/InputStatementPasscode.vue"));
Vue.component("ButtonEdit", () => import("./components/element/ButtonEdit.vue"));
Vue.component("Tooltip", () => import("./components/element/Tooltip.vue"));
Vue.component("SwitchComponent", () => import("./components/element/SwitchComponent.vue"));
Vue.component("ModalBox", () => import("./components/modal/ModalBox.vue"));
Vue.component("Radio", () => import("./components/element/Radio.vue"));
Vue.component("CheckBox", () => import("./components/element/CheckBox.vue"));
Vue.component("InputBranchMerchantPnd", () => import("./components/element/InputBranchMerchantPnd.vue"));
Vue.component("InputCitizenIdPnd53", () => import("./components/element/InputCitizenIdPnd53.vue"));
